module.exports = __webpack_public_path__ + "img/sylogos.e12d36fb.png";